import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalLayoutComponent } from "../modal-layout/modal-layout.component";
import { ButtonComponent } from "../../button/button.component";
import { UI_FORM_IMPORTS } from '../../../ui-form-imports';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'lib-archive-submission-modal',
  imports: [
    ModalLayoutComponent,
    ButtonComponent,
    ...UI_FORM_IMPORTS,
    ReactiveFormsModule
],
  templateUrl: './archive-submission-modal.component.html',
  styleUrl: './archive-submission-modal.component.scss',
})
export class ArchiveSubmissionModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ArchiveSubmissionModalComponent>);
  agencyName = this.data.agencyName;
  submissionNumber = this.data.submissionNumber;
  confirm = new UntypedFormControl('');

  onSubmit() {
    this.dialogRef.close(true);
  }
}
